import { render, staticRenderFns } from "./ngo-landing-section.vue?vue&type=template&id=cf0f6644&scoped=true&"
import script from "./ngo-landing-section.vue?vue&type=script&lang=js&"
export * from "./ngo-landing-section.vue?vue&type=script&lang=js&"
import style0 from "./ngo-landing-section.vue?vue&type=style&index=0&id=cf0f6644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0f6644",
  null
  
)

export default component.exports